import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";
import Constants from "../../services/constants";
import { showToast } from "./toastSlice";

const initialState = {
  data: null,
  isLoading: false,
  error: null
};

export const getConfigurations = createAsyncThunk(
  "configuration/get",
  async ({plan_id,flag,type}, { dispatch }) => {
    try {
      const res = await api("get", Constants.END_POINT.configuration,{},{},{plan_id,flag,type});
      if (res?.success && res?.data) {
        return res.data;
      }
      throw new Error(res.message || "Failed to fetch configurations");
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      throw error;
    }
  }
);

const configurationSlice = createSlice({
  name: "configuration",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getConfigurations.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getConfigurations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getConfigurations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  }
});

export default configurationSlice.reducer;
